import NewsletterThirtyOneContainer from "./container/NewsletterThirtyOneContainer";
export default NewsletterThirtyOneContainer;
